// extracted by mini-css-extract-plugin
export default {"cursor":"Cursors_cursor__eNtmD","cursorName":"Cursors_cursorName__MPuA9"};